<template>
  <div>
    <div class="tit">
      <span>员工认证</span>
    </div>
    <div class="body_content">
      <el-form :model="params" ref="myform">
        <el-form-item label-width="170px" prop="incubator_id" label="认证园区：" :rules="[{ required: true, message: '请选择园区', trigger: 'blur' }]">
          <el-select
            v-model="params.incubator_id"
            filterable
            :loading="loading"
            placeholder="可直接输入“关键词”进行检索"
            class="input-width"
            :disabled="incubatorDisabled"
          >
            <el-option
              v-for="item in incubator_authenticate"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="170px" prop="enterprise_name" label="所属公司：" :rules="[{ required: true, message: '请输入公司名称', trigger: 'blur' }]">
          <el-input
            :class="{changecolor:params.enterprise_id.length}"
            class="input-width"
            suffix-icon="el-icon-success"
            v-model="params.enterprise_name"
            @blur="checkEnterprise"
            :disabled="enterpriseDisabled"
          ></el-input>
          <span style="padding-left:10px;color:green;" v-if="params.enterprise_id.length">企业名称查询成功</span>
        </el-form-item>
        <el-form-item label-width="170px" prop="name" label="姓名："  :rules="[{ required: true, message: '请输入员工姓名：', trigger: 'blur' }]">
          <el-input class="input-width" v-model="params.name"></el-input>
        </el-form-item>
        <el-form-item
          label-width="170px"
          prop="sex"
          label="性别："
          :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
        >
          <el-select class="input-width" v-model="params.sex" placeholder="请选择性别">
            <el-option label="男" value="SexMan"></el-option>
            <el-option label="女" value="SexWoMan"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="170px" prop="mobile" label="联系电话：">
          <div>
            <el-input class="input-width" v-model="params.mobile" disabled></el-input>
          </div>
          <changeMobile class="input-width" @receiveMobile="receiveMobile"></changeMobile>
        </el-form-item>
        <el-form-item label-width="170px" prop="id_num" label="身份证号：" :rules="[{ required: true, message: '请输入身份证号', trigger: 'blur' }]">
          <el-input class="input-width" v-model="params.id_num"></el-input>
        </el-form-item>

        <el-form-item label-width="170px" prop="department" label="所属部门：" :rules="[{ required: true, message: '请输入所属部门', trigger: 'blur' }]">
          <el-input class="input-width" v-model="params.department"></el-input>
        </el-form-item>
        <el-form-item label-width="170px" prop="position" label="职位：" :rules="[{ required: true, message: '请输入所在职位', trigger: 'blur' }]">
          <el-input class="input-width" v-model="params.position"></el-input>
        </el-form-item>
        <el-form-item label-width="170px" label="工号（非必填）：">
          <el-input class="input-width" v-model="params.job_num" placeholder="示例：007"></el-input>
        </el-form-item>
        <el-form-item label-width="170px" label="认证申请说明：">
          <el-input
            class="textarea-width"
            maxlength="200"
            show-word-limit
            rows="6"
            type="textarea"
            v-model="params.explain"
            placeholder="可对认证内容进行进一步说明，便于企业快速完成审核，字数不超过200字。"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="170px" label>
          <el-button type="primary" @click="save('IdentityCertifieStatusNotSubmitted')">暂存</el-button>
          <el-button type="primary" @click="submit('IdentityCertifieStatusSubmitted')">提交审核</el-button>
          <el-button @click="go('employee_certification_table_list');">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
     <!-- 提交成功提示 -->
      <succcessfulDialog @close="close" :dialogVisible="dialogVisible3"></succcessfulDialog>
  </div>
</template>

<script>
import uploadFile from "@/components/file_upload/uploadFile.vue";
import provincialSelection from "@/components/provincial_selection/provincial_selection.vue";
import changeMobile from "@/components/changeMobile/change_mobile";
import succcessfulDialog from "@/components/dialog/succcessful.vue";
export default {
  components: {
    uploadFile,
    provincialSelection,
    changeMobile,
    succcessfulDialog
  },
  data() {
    return {
      params: {
        enterprise_id:''
      },
      incubator_authenticate: [], //孵化器园区列表
      loading: false,
      incubatorDisabled: false, //已暂存过园区不给选择
      enterpriseDisabled:false,//已暂存过企业不给选择
       dialogVisible3:false,//成功提示
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.$store.state.info) {
      this.getAuthenticateEmployees(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("getAuthenticateEmployees");
    }
    this.getList(); //园区列表
    this.getDictionaries("Field").then(res => {
      //主营业务领域
      this.Field = res;
    });
  },
  methods: {
    /* 监测Props */
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    /** 员工认证中通过园区校验企业名称*/
    checkEnterprise(){
      let params = {
        incubator_id:this.params.incubator_id,
        name:this.params.enterprise_name
      }
      this.api.checkEnterprise(params).then(res=>{
        if (res.error.err_code !== 0) return;
        if(res.obj.id){
          this.params.enterprise_id = res.obj.id;
        }else{
          this.params.enterprise_id = '';
          this.params.enterprise_name = '';
          this.$message.info('没有查询到该企业');
        }
      })
    },
    //条件查询孵化器园区列表
    getList(obj) {
      return new Promise(resolve => {
        this.api.getList().then(res => {
          resolve(res);
          if (res.error.err_code !== 0) return;
          this.incubator_authenticate = res.obj.list || [];
          if (!this.incubator_authenticate.length && obj) {
            this.$message.info(
              "未查询到你要找的园区，请重新输入或与园区确认是否已完成入库"
            );
          }
        });
      });
    },
    /**获取对应类型字典封装
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list || [];
          list = list.length ? list : null;
          resolve(list);
        });
      });
    },
    /** 查询认证 用于二次编辑*/
    getAuthenticateEmployees() {
      if (
        !this.$route.query.id &&
        !sessionStorage.getItem("employeeCertificationTmpId")
      ) {
        this.params.mobile = this.info.mobile;
        return;
      }
      let params = {
        id:
          this.$route.query.id ||
          sessionStorage.getItem("employeeCertificationTmpId")
      };
      this.api.getAuthenticateEmployees(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];

        let obj = list.length ? res.obj.list[0] : {};
        if (!list.length || obj.mobile === "") {
          //手机号
          obj.mobile = this.info.mobile;
        }
        obj.field_ids = (obj.field_ids && obj.field_ids.split(",")) || [];
        this.params = Object.assign({}, this.params, obj);
        this.incubatorDisabled = obj.incubator_id ? true : false; //园区选择控制
        this.enterpriseDisabled = obj.enterprise_id ? true : false; //公司选择控制
        this.checkEnterprise();//验证公司是否和园区对应
      });
    },
    /** 提交表单验证*/
    submit(type) {
      this.$refs["myform"].validate(valid => {
        if (valid) {
          this.save(type);
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
    },
    /** 保存表单内容*/
    save(type) {

      let params = {
        operation: type,
        id: this.$route.query.id,
        ...this.params,
      };
      this.api.saveOrSubmitAuthenticateEmployee(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        this.$message.success("操作成功");
        if (type === "IdentityCertifieStatusNotSubmitted") {
          //暂存
          let tmpId = res.obj.id;
          sessionStorage.setItem("employeeCertificationTmpId", tmpId);
          this.enterpriseDisabled =this.incubatorDisabled = tmpId ? true : false; //园区选择控制
          this.getAuthenticateEmployees();
        } else {
          //提交
         this.dialogVisible3 = true;
        }
      });
    },
    go(name) {
      this.$router.push({
        name: name
      });
    },
    //更换手机号（子组件传值）
    receiveMobile(obj) {
      this.params.mobile = obj.mobile;
    },
    close(obj){
      if(obj.name === 'succ'){
        this.dialogVisible3 = false;
        this.$router.push({ name: "employee_certification_table_list" });
      }
    }
  }
};
</script>

<style lang="scss">
.changecolor{
  .el-input__suffix{
    color:green;
  }
}
</style>
